/*
  Reels op de over-onspagina.

  De <source>-elementen staan met data-src in de HTML, niet met src. Zo
  haalt de browser bij het laden van de pagina niets binnen: je ziet
  alleen het stilstaande beeld. Pas bij een klik op de afspeelknop wordt
  de echte src gezet, load() aangeroepen en gestart.

  Waarom niet gewoon preload="none": dat helpt, maar Safari negeert het
  bij een zichtbare video met poster en begint alsnog te bufferen. Met
  data-src is er domweg geen bron om te laden.

  Let op de volgorde rond load(). Meteen na load() play() aanroepen gaat
  mis: load() zet het element terug naar readyState 0 en breekt de net
  gestarte play() af met een AbortError. De eerste klik lijkt dan niets
  te doen en pas de tweede werkt. Daarom wachten we op canplay voordat
  we starten -- alleen de eerste keer, want daarna is de bron er al.

  De is-speelt-klasse (die het stilstaande beeld wegfadet en de knop
  verbergt) hangt aan de play- en pause-events, niet aan de klik. Zo
  blijft het beeld staan zolang er nog geladen wordt, in plaats van een
  leeg vlak te tonen.

  Er speelt er hoogstens een tegelijk -- start je een tweede, dan
  pauzeert de eerste. Vier reels die door elkaar heen praten is geen
  kijkervaring.
*/
(function () {
  var spelers = document.querySelectorAll('[data-oo-reel]');
  if (!spelers.length) return;

  var actief = null;

  function laad(video) {
    if (video.dataset.geladen === 'ja') return;
    var bronnen = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < bronnen.length; i++) {
      bronnen[i].src = bronnen[i].getAttribute('data-src');
    }
    video.dataset.geladen = 'ja';
    video.load();
  }

  function start(video, speler) {
    var poging = video.play();
    if (!poging || !poging.catch) return;
    poging.catch(function (fout) {
      /* AbortError betekent dat een nieuwe load() ertussen kwam; de
         canplay-handler pikt het dan alsnog op. Bij elke andere fout --
         een browser die afspelen blokkeert, een bron die niet laadt --
         zetten we de tegel terug zodat het beeld met de knop blijft
         staan in plaats van een zwart vlak. */
      if (fout && fout.name === 'AbortError') return;
      speler.classList.remove('is-speelt');
      video.dataset.bezig = '';
    });
  }

  spelers.forEach(function (speler) {
    var video = speler.querySelector('video');
    var knop = speler.querySelector('[data-oo-reel-knop]');
    if (!video || !knop) return;

    knop.addEventListener('click', function () {
      /* Op dataset.bezig sturen en niet op video.paused: tussen de klik
         en het daadwerkelijke afspelen zit de laadtijd, en in dat gat is
         paused nog true. Zonder deze vlag zou een tweede klik in dat gat
         een tweede keer starten. */
      if (video.dataset.bezig === 'ja') {
        video.pause();
        video.dataset.bezig = '';
        if (actief === video) actief = null;
        return;
      }

      if (actief && actief !== video) {
        actief.pause();
        actief.dataset.bezig = '';
      }

      video.dataset.bezig = 'ja';
      actief = video;

      var moest_laden = video.dataset.geladen !== 'ja';
      laad(video);

      if (!moest_laden || video.readyState >= 3) {
        start(video, speler);
      } else {
        video.addEventListener(
          'canplay',
          function () {
            if (video.dataset.bezig === 'ja') start(video, speler);
          },
          { once: true }
        );
      }
    });

    video.addEventListener('play', function () {
      speler.classList.add('is-speelt');
    });

    video.addEventListener('pause', function () {
      speler.classList.remove('is-speelt');
      video.dataset.bezig = '';
    });
  });
})();
